import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { SkipAuthHeader } from './auth.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.has(SkipAuthHeader)) {
      req = req.clone({ headers: req.headers.delete(SkipAuthHeader) });
      return next.handle(req);
    }
    const token = localStorage.getItem('token');
    if (token) {
      req = req.clone({ headers: req.headers.set('x-auth-token', token) });
    }
    return next.handle(req).pipe(
      catchError((error): Observable<any> => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          localStorage.removeItem('token');
        }
        return throwError(error);
      })
    );
  }
}
